import React, { useState } from 'react'
import { Header2 } from '@flatsy/core/MaterialUi/Typo'
import { useApplicationDetails } from 'src/hooks/ApplicationDetails'
import LoaderWrapper from '@flatsy/core/Loader/Wrapper'
import BookingsSelector from 'src/containers/Qualification/Steps/Booking'
import { LayoutCards } from '@flatsy/core/Layout/Cards'
import FormProvider from 'src/containers/Qualification/Context'
import { FrontApplicationBookingState } from '@flatsy/types/Applications/BookingStatus'
import theme from '@flatsy/core/MuiTheme/theme'
import { useStyles } from './Style'

const BookingSelection: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const {
    application: { application },
    asset,
    fetch,
  } = useApplicationDetails()

  if (!asset || !application) {
    return <></>
  }

  const handleFetch = async () => {
    setLoading(true)
    await fetch()
    setLoading(false)
  }

  return (
    <div className={classes.container}>
      <LayoutCards className={classes.main}>
        <Header2 fontColor={theme.palette.primary.dark} className={classes.bookingHeaderTitle}>
          {application.computedBookingState === FrontApplicationBookingState.RESCHEDULED
            ? 'Choix du nouveau créneau pour votre visite'
            : 'Choix du créneau pour votre visite'}
        </Header2>
        <FormProvider>
          <BookingsSelector
            withOutApplication={false}
            assetId={asset.id}
            paramsUrl={application.id || ''}
            updateBooking
            fetchApplication={handleFetch}
          />
        </FormProvider>
      </LayoutCards>
      {loading && <LoaderWrapper />}
    </div>
  )
}

export default BookingSelection
